'use client'

import { useEffect } from 'react'
import { Datadog } from '../utils/scalis-datadog'

interface DatadogInitProps {
  user?: {
    id: string
    email: string
    name: string
  }
}

const DatadogInit = ({ user }: DatadogInitProps) => {
  useEffect(() => {
    const initializeDatadog = async () => {
      try {
        await Datadog.initialize()

        if (user && Datadog.rum) {
          Datadog.rum.setUser({
            id: user.id,
            email: user.email,
            name: user.name,
          })
        }
      } catch (error) {
        if (Datadog.logs) {
          Datadog.logs.logger.error('Failed to initialize Datadog:', error)
        } else {
          // eslint-disable-next-line no-console
          console.error('Failed to initialize Datadog:', error)
        }
      }
    }

    initializeDatadog()
  }, [user])

  return null
}

export default DatadogInit
